
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AssistantForm } from "./assistant/AssistantForm";
import { useAssistantForm } from "./assistant/hooks/useAssistantForm";
import { useAssistantCreation } from "./assistant/useAssistantCreation";
import { toast } from "sonner";

interface CreateAssistantDialogProps {
  onSave: (assistant: { id: string; name: string; }) => void;
  onClose: () => void;
}

const CreateAssistantDialog = ({ onSave, onClose }: CreateAssistantDialogProps) => {
  const { isLoading, createAssistant } = useAssistantCreation(onSave, onClose);
  const {
    instructions,
    setInstructions,
    isEnhancing,
    handleEnhanceInstructions
  } = useAssistantForm(onSave);

  const handleSubmit = async (data: any) => {
    try {
      await createAssistant(data);
    } catch (error) {
      console.error('Error in CreateAssistantDialog:', error);
      toast.error(error instanceof Error ? error.message : "Failed to create assistant");
      onClose(); // Close dialog even on error
    }
  };

  return (
    <DialogContent className="sm:max-w-[600px]">
      <DialogHeader>
        <DialogTitle>Create New Assistant</DialogTitle>
      </DialogHeader>
      <AssistantForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        isEnhancing={isEnhancing}
        instructions={instructions}
        onInstructionsChange={setInstructions}
        onEnhanceInstructions={handleEnhanceInstructions}
      />
    </DialogContent>
  );
};

export default CreateAssistantDialog;
